import React from "react";
import { IonCol, IonRow } from "@ionic/react";

import "./Logs.css"

interface Data {
    log_id: string;
    log_user: string;
    log_service_name: string;
    log_info: string,
    log_created_at: string;
    event_id: string;
    event_name: string;
    event_description: string;
    event_type: string;
}

interface Props {
    logsData: Data;
}

const LogsTable: React.FC<Props> = (props): JSX.Element => {

    return (
        <IonRow className='user-table-rows'>
            <IonCol sizeXl="2" sizeXs="8">{props.logsData.event_name}</IonCol>
            <IonCol sizeXl="3" className="mobile-hidden">{props.logsData.event_description}</IonCol>
            <IonCol sizeXl="2" className="mobile-hidden">{props.logsData.log_info}</IonCol>
            <IonCol sizeXl="2" sizeXs="4">{props.logsData.log_user}</IonCol>
            <IonCol sizeXl="2" className="mobile-hidden">{props.logsData.log_service_name}</IonCol>
            <IonCol sizeXl="1" className="mobile-hidden">{props.logsData.log_created_at}</IonCol>
        </IonRow>
    )
}

export default LogsTable;